import { selectSort } from '@/data/replenishmentPlan/slice/replenishmentPlan.selectors.ts'
import { SortBy } from '@/data/replenishmentPlan/slice/replenishmentPlan.types.ts'
import { replenishmentPlanActions } from '@/data/replenishmentPlan/slice/replenishmentPlan.slice.ts'
import { useTranslation } from 'react-i18next'
import { useEffect, useMemo } from 'react'
import { CustomSortGroup } from '@/ui/components/CustomSortGroup'
import { useDispatch, useSelector } from 'react-redux'
import { useTrackReplenishmentPlanAnalyticsEvent } from '@/core/hooks/useTrackReplenishmentPlanAnalyticsEvent.ts'
import { DatagridSortingEvent } from '@/core/analytics/events/replenishmentPlan/DatagridSortingEvent.ts'

const TableSort = () => {
  const { trackReplenishmentPlanAnalyticsEvent } =
    useTrackReplenishmentPlanAnalyticsEvent()

  const sort = useSelector(selectSort)

  const dispatch = useDispatch()

  useEffect(() => {
    trackReplenishmentPlanAnalyticsEvent(
      new DatagridSortingEvent({
        type:
          sort.sortBy === SortBy.cost
            ? 'cost'
            : sort.sortBy === SortBy.unitPrice
              ? 'units'
              : 'alphabetically',
      }),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackReplenishmentPlanAnalyticsEvent])

  const onChange = (sortBy: SortBy) => {
    trackReplenishmentPlanAnalyticsEvent(
      new DatagridSortingEvent({
        type:
          sortBy === SortBy.cost
            ? 'cost'
            : sortBy === SortBy.unitPrice
              ? 'units'
              : 'alphabetically',
      }),
    )

    dispatch(replenishmentPlanActions.setSortBy(sortBy))
  }

  const { t } = useTranslation()

  const sortByToText: Record<SortBy, string> = useMemo(
    () => ({
      [SortBy.cost]: t('tableSort.cost'),
      [SortBy.unitPrice]: t('tableSort.unitPrice'),
      [SortBy.alphabetically]: t('tableSort.alphabetically'),
    }),
    [t],
  )

  const sortByToTooltip: Record<SortBy, string> = useMemo(
    () => ({
      [SortBy.cost]: t('tableSort.costTooltip'),
      [SortBy.unitPrice]: t('tableSort.unitPriceTooltip'),
      [SortBy.alphabetically]: t('tableSort.alphabeticallyTooltip'),
    }),
    [t],
  )

  return (
    <CustomSortGroup
      value={sort.sortBy}
      asc={sort.asc}
      options={[SortBy.alphabetically, SortBy.cost, SortBy.unitPrice]}
      optionToString={(option) => sortByToText[option]}
      getTooltipText={(option) => sortByToTooltip[option]}
      onChange={onChange}
    />
  )
}

export default TableSort
